import React from 'react';
import './Footer.css';

import socialX from '../../static/images/social-x.svg';
import socialGithub from '../../static/images/social-github.svg';
import socialBluesky from '../../static/images/social-bluesky.svg';
import socialStackoverflow from '../../static/images/social-stackoverflow.svg';
import socialLinkedin from '../../static/images/social-linkedin.svg';

export default function Footer() {
  return (
    <footer className="sc-footer">
      <div className="sc-footer__socials">
        <p className="sc-footer__follow">Follow us</p>
        <div className="sc-footer__icons">
          <a
            href="https://x.com/soundclouddev"
            target="_blank"
            rel="noopener noreferrer"
            title="@SoundCloudDev on X"
          >
            <img src={socialX} alt="X" width={24} height={24} />
          </a>
          <a
            href="https://github.com/soundcloud"
            target="_blank"
            rel="noopener noreferrer"
            title="SoundCloud on GitHub"
          >
            <img src={socialGithub} alt="GitHub" width={24} height={24} />
          </a>
          <a
            href="https://bsky.app/profile/soundcloud.dev"
            target="_blank"
            rel="noopener noreferrer"
            title="@soundcloud.dev on Bluesky"
          >
            <img src={socialBluesky} alt="Bluesky" width={24} height={24} />
          </a>
          <a
            href="https://stackoverflow.com/questions/tagged/soundcloud"
            target="_blank"
            rel="noopener noreferrer"
            title="SoundCloud on Stack Overflow"
          >
            <img src={socialStackoverflow} alt="Stack Overflow" width={20} height={24} />
          </a>
          <a
            href="https://www.linkedin.com/company/soundcloud"
            target="_blank"
            rel="noopener noreferrer"
            title="SoundCloud on LinkedIn"
          >
            <img src={socialLinkedin} alt="LinkedIn" width={24} height={24} />
          </a>
        </div>
      </div>
      <ul className="sc-footer__links">
        <li>
          <a
            href="https://status.soundcloud.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            Status
          </a>
        </li>
        <li>
          <a href="https://developers.soundcloud.com/docs/api/privacy">
            Privacy
          </a>
        </li>
        <li>
          <a href="https://developers.soundcloud.com/docs/api/cookies">
            Cookies
          </a>
        </li>
        <li>
          <button
            type="button"
            className="sc-footer__cookieManager"
            onClick={() => {
              if (typeof window !== 'undefined' && window.SCConsent) {
                window.SCConsent.showConsentDialog();
              }
            }}
          >
            Cookie Manager
          </button>
        </li>
        <li>
          <a
            href="https://soundcloud.com/imprint"
            target="_blank"
            rel="noopener noreferrer"
          >
            Imprint
          </a>
        </li>
      </ul>
    </footer>
  );
}
